import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSupportedUserLogActions} from 'src/openapi/admin/apis/AuditLogDictionaryApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useGetUserLogActionDictionary = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getSupportedUserLogActions({userId}),
    ), [apiDispatch, userId]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
